import React, { useContext } from 'react';
import { LabelContext } from '../labels/LabelContext';
import { ValidationState, InlineOrBlockSize } from '../Types';
import classNames from 'classnames';
import styles from './Checkbox.scss';

export type CheckboxType = 'checkbox' | 'radio';

export interface CheckboxProps {
  /**
   * Id of the element
   */
  id: string;
  /**
   * Name of the element
   */
  name?: string;
  /**
   * Control type
   */
  type?: CheckboxType;
  /**
   * Content appearing after the control
   */
  label: string | JSX.Element;
  /**
   * Makes element checked
   */
  checked: boolean;
  /**
   * Handles clicks
   */
  onChange: (v: boolean) => void;
  /**
   * Sets element size
   */
  size?: InlineOrBlockSize;
  /**
   * Disables element
   */
  disabled?: boolean;
  /**
   * Validation state
   */
  state?: ValidationState;
  /**
   * Custom class
   */
  className?: string;

  describedby?: string;

  required?: boolean;
}

/**
 * Primary UI component for user interaction
 */
export const Checkbox: React.FC<CheckboxProps> = ({ type = 'checkbox', ...props }) => {
  const ctx = useContext(LabelContext);

  const state = ctx.state || props.state;

  return (
    <div
      className={classNames(
        styles['au-control-input'],
        {
          [styles[`au-control-input--${state}`]]: state,
          [styles[`au-control-input--block`]]: props.size == 'block',
        },
        props.className,
      )}>
      <input
        id={props.id}
        name={props.name}
        aria-describedby={ctx.describedBy}
        className={styles['au-control-input__input']}
        type={type}
        role={type}
        checked={props.checked}
        onChange={(e) => props.onChange && props.onChange(e.target.checked)}
        disabled={props.disabled}
        aria-labelledby={props.describedby || ctx.describedBy}
      />
      <label className={styles['au-control-input__text']} htmlFor={props.id}>
        {props.label} {props.required ? <span className={styles['au-control-required-icon']} aria-hidden="true"></span> : <></>}
      </label>
    </div>
  );
};
